var React = require('react');

function Status (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14.1668","cy":"6.66665","r":"3.33333","fill":"#577DF6","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.8332 6.66665C12.8332 5.93027 13.4301 5.33331 14.1665 5.33331C14.9029 5.33331 15.4998 5.93027 15.4998 6.66665C15.4998 6.72309 15.4963 6.77871 15.4895 6.83331H12.8435C12.8367 6.77871 12.8332 6.72309 12.8332 6.66665ZM8.83572 6.83331C8.83403 6.77797 8.83317 6.72241 8.83317 6.66665C8.83317 6.02248 8.94737 5.40499 9.15663 4.83331H4.1665C3.61422 4.83331 3.1665 5.28103 3.1665 5.83331C3.1665 6.3856 3.61422 6.83331 4.1665 6.83331H8.83572ZM9.36933 8.99998H4.1665C3.61422 8.99998 3.1665 9.44769 3.1665 9.99998C3.1665 10.5523 3.61422 11 4.1665 11H11.0567C10.3413 10.4857 9.75854 9.79869 9.36933 8.99998ZM4.1665 13.1666C3.61422 13.1666 3.1665 13.6144 3.1665 14.1666C3.1665 14.7189 3.61422 15.1666 4.1665 15.1666H15.8332C16.3855 15.1666 16.8332 14.7189 16.8332 14.1666C16.8332 13.6144 16.3855 13.1666 15.8332 13.1666H4.1665Z","fill":"#577DF6","key":1})]);
}

Status.displayName = "Status";

Status.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Status;

Status.default = Status;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/status.svg
// module id = 1682
// module chunks = 0